import { Bullets } from "ui-components";
import UserImage from "../../../../utils/Images/UserImage";
import { manageDuplicateSkills } from "../../../../utils/Common/Constant";
import { useTranslation } from "react-i18next";
import { useState } from "react";
interface QuestionResponsePopupHeader {
  setShowQuestion: any;
  assessmentApplicantDetails: any;
  assessmentSkill: any;
  assessmentDetails: any;
  assessmentDateTime: string;
  setIsMaximize: any;
  isMaximize: boolean;
}
const QuestionResponsePopupHeader: React.FC<QuestionResponsePopupHeader> = ({
  assessmentApplicantDetails,
  assessmentSkill,
  assessmentDetails,
  assessmentDateTime,
}) => {
  const { t } = useTranslation();
  const [accordOpen, setAccordOpen] = useState<boolean>(true);
  return (
    <>
      <div className="contentUserIcon">
        <div className="userIcon">
          <div className="userImageBorder">
            {assessmentApplicantDetails?.applicantImage === null ? (
              <UserImage />
            ) : (
              <img src={assessmentApplicantDetails?.applicantImage} alt="" />
            )}
          </div>
        </div>
        <div className="content">
          <div className="w-100">
            <span className="nameSurname">
              {assessmentApplicantDetails?.displayName}
            </span>
            <p className="programingName">
              {assessmentApplicantDetails?.title}
            </p>
          </div>
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <div className="contentHead">
                  <button
                    className="accordion-button expandBtn collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                    onClick={() => setAccordOpen(!accordOpen)}
                  >
                    <h6>
                      {accordOpen ? t("GENERAL.EXPAND") : t("GENERAL.COLLAPSE")}
                    </h6>
                  </button>
                </div>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  {assessmentSkill?.length > 0 && (
                    <div className="bullets">
                      {(manageDuplicateSkills(assessmentSkill) ?? []).map(
                        (skillList: any) => (
                          <Bullets
                            key={Math.random()}
                            skillName={skillList?.skillName ?? ""}
                          />
                        ),
                      )}
                    </div>
                  )}
                  <div className="dateTime">
                    <span>{assessmentDateTime}</span>
                    <span className="dateTimepipe">|</span>
                    <span>
                      {t("CREATE_ASSESSMENT.DURATION")} :-{" "}
                      {assessmentDetails?.totalTime} {t("GENERAL.MINS")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionResponsePopupHeader;
